'use strict';

/* globals $ */

var _ = require('lodash');

var at = require('../utils/environment');
var breakpoints = require('../utils/breakpoints');


var viewportWidth = 0;
var refreshWidth = _.throttle(function() {
    viewportWidth = $(window).width();
}, 1000, { trailing: false });

var pageLoaded = false;
if (at.client && window.$) $(window).on('load', function() {
    pageLoaded = true;
});

var CardStore = function(feed) {
    this._feed = feed;
};

CardStore.prototype = {

_immediateRender: true,
_cards: [],
_placeholders: [],

turnImmediateRenderOff: function() {
    this._immediateRender = false;
},

pick: function(info) {
    var card;
    var answer = false;
    var skippedCards = [];

    if (at.client) {
        if (window.$) refreshWidth();
        if (viewportWidth > breakpoints.MOBILE_TO_DESKTOP) return;
    }

    while (answer === false && (card = this._cards.shift())) {
        try {
            answer = card.answerInvitation(info);
        }
        catch(error) {
            console.warn('Soft error: failed to invite card', card);
            console.error(error);
        }
        if (answer === false) skippedCards.push(card);
    }
    this._cards.push.apply(this._cards, skippedCards);

    if (pageLoaded && card === undefined) return;
    else return this._newPlaceholder(card);
},

_bindCardToPlaceholder: function(placeholder, card) {
    placeholder.card = card;
    placeholder.klass = card.klass;
},

_newPlaceholder: function(card) {
    var placeholder = { type: 'card', card: null };
    if (this._immediateRender) this._placeholders.push(placeholder);
    if (card) this._bindCardToPlaceholder(placeholder, card);
    return placeholder;
},

bindEvents: function() {
    if (window.$)
        $(this._feed.refs.feed).on('card_register.bastian', _.bind(function(event, card) {
            this._register(card);
        }, this));
},

unbindEvents: function() {
    if (window.$) $(this._feed.refs.feed).off('card_register.bastian');
},

_register: function(card) {
    var placeholder;
    if (this._immediateRender && (placeholder = this._placeholders.shift())) {
        this._bindCardToPlaceholder(placeholder, card);
        this._feed.itemsChanged();
    }
    else this._cards.push(card);
}

};

module.exports = CardStore;
